import {
  getChannelList, addChannel, editChannel, deleteChannel, detailChannel,
  getVideosList, addVideos, editVideos, detailVideos, deleteVideos, publishVideos, getCategoryList,
  getRecommendedVideos, getSearchVideos, setRecommendedVideos,
  getPlaylists, reOrderPlaylists, deletePlaylists, addPlaylists, detailPlaylists, editPlaylists, searchVideosPlaylists, setStatusPlaylists
} from '@/services/missionsvideos';

const getters = {
  listChannel: state => state.listChannel,
  totalListChannel: state => state.totalListChannel,
  listVideos: state => state.listVideos,
  totalListVideos: state => state.totalListVideos,
  listCategoryVideos: state => state.listCategoryVideos,
  percentCompleted: state => state.percentCompleted,
  listPlaylist: state => state.listPlaylist,
  listVideoSearch: state => state.listVideoSearch,
};

const actions = {
  async requestListChannel({ commit }, filter) {
    let res = []
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getChannelList(filter);
      res = response.data.data;
      commit('SET_LIST_CHANNEL', { listChannel: response.data.data, totalListChannel: response.data.total });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res
  },
  async requestAddChannel({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addChannel(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditChannel({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editChannel(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeleteChannel({ commit, dispatch }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteChannel(data);
      dispatch('requestListChannel', filter);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailChannel({ commit }, data) {
    let response = null;
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const res = await detailChannel(data);
      response = res.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  // Videos
  async requestListVideos({ commit }, { data, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getVideosList(data, filter);
      commit('SET_LIST_VIDEOS', { listVideos: response.data.data, totalListVideos: response.data.total });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestAddVideos({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
      toggle: true,
      message: 'please wait...',
    }, { root: true });
    try {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
        toggle: true,
        message: 'uploading 0%',
      }, { root: true });
      await addVideos(data, (event) => {
        const percentCompleted = Math.round((100 * event.loaded) / event.total);
        commit('SET_PERCENTAGE_UPLOAD', percentCompleted);
        commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
          toggle: true,
          message: percentCompleted === 100 ? 'saving data...' : `uploading ${percentCompleted}%`,
        }, { root: true });
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
        toggle: false,
        message: 'please wait...',
      }, { root: true });
    }
  },
  async requestEditVideos({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
      toggle: true,
      message: 'please wait...',
    }, { root: true });
    try {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
        toggle: true,
        message: 'uploading 0%',
      }, { root: true });
      await editVideos(data, (event) => {
        const percentCompleted = Math.round((100 * event.loaded) / event.total);
        commit('SET_PERCENTAGE_UPLOAD', percentCompleted);
        commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
          toggle: true,
          message: percentCompleted === 100 ? 'saving data...' : `uploading ${percentCompleted}%`,
        }, { root: true });
      });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('SET_PERCENTAGE_UPLOAD', 0);
      commit('NotificationModule/TOGGLE_LOADING_WITH_MESSAGE', {
        toggle: false,
        message: 'please wait...',
      }, { root: true });
    }
  },
  async requestDeleteVideos({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deleteVideos(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailVideos({ commit }, data) {
    let response = null;
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const res = await detailVideos(data);
      response = res.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async requestPublishVideos({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await publishVideos(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestListCategoryVideos({ commit }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getCategoryList();
      commit('SET_LIST_CATEGORY_VIDEOS', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestGetRecommendedVideos({ commit }) {
    let response = null;
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const res = await getRecommendedVideos();
      response = res.data;
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return response;
  },
  async requestSearchVideos({ commit }, params) {
    let response = [];
    try {
      const res = await getSearchVideos(params);
      response = res.data;
      // eslint-disable-next-line no-empty
    } catch (err) {}
    return response;
  },
  async requestSetRecommendedVideos({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setRecommendedVideos(data);
      commit('NotificationModule/SET_STATUS', { status: 200, message: '', errorCode: '' }, { root: true });
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: 'error-set-recom-videos' }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  // Playlist
  async requestGetPlaylists({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await getPlaylists(data);
      commit('SET_LIST_PLAYLIST', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSearchVideoPlaylist({ commit }, { id, filter }) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await searchVideosPlaylists(id,filter);
      commit('SET_LIST_VIDEO_SEARCH', response.data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestCreatePlaylist({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await addPlaylists(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestEditPlaylist({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await editPlaylists(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDeletePlaylist({ commit, dispatch }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await deletePlaylists(data);
      dispatch('requestGetPlaylists',{
        id: data.channel_id
      })
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestReOrderPlaylist({ commit }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await reOrderPlaylists(data);
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestSetStatusPlaylist({ commit, dispatch }, data) {
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      await setStatusPlaylists(data);
      dispatch('requestGetPlaylists',{
        id: data.channel_id
      })
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
  },
  async requestDetailPlaylist({ commit }, id) {
    let res = null
    commit('NotificationModule/TOGGLE_LOADING', true, { root: true });
    try {
      const response = await detailPlaylists(id);
      res = response.data
    } catch (err) {
      commit('NotificationModule/SET_STATUS', { status: 400, message: `${err.data.message}`, errorCode: null }, { root: true });
    } finally {
      commit('NotificationModule/TOGGLE_LOADING', false, { root: true });
    }
    return res
  },
};

const mutations = {
  SET_LIST_CHANNEL(state, { listChannel, totalListChannel }) {
    state.listChannel = listChannel;
    state.totalListChannel = totalListChannel;
  },
  SET_LIST_VIDEOS(state, { listVideos, totalListVideos }) {
    state.listVideos = listVideos;
    state.totalListVideos = totalListVideos;
  },
  SET_LIST_CATEGORY_VIDEOS(state, listCategoryVideos) {
    state.listCategoryVideos = listCategoryVideos;
  },
  SET_PERCENTAGE_UPLOAD(state, percentage) {
    state.percentCompleted = percentage;
  },
  SET_LIST_PLAYLIST(state, listPlaylist) {
    state.listPlaylist = listPlaylist;
  },
  SET_LIST_VIDEO_SEARCH(state, listVideoSearch) {
    state.listVideoSearch = listVideoSearch;
  },
};

export default {
  namespaced: true,
  state: {
    listChannel: [],
    totalListChannel: 0,
    listVideos: [],
    totalListVideos: 0,
    listCategoryVideos: [],
    percentCompleted: 0,
    listPlaylist: [],
    listVideoSearch: [],
  },
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/stores/MissionsVideos/index.js